import styled, { css } from 'styled-components'

export const roadMapCircle = css`
  width: 18px;
  height: 18px;
  background: #766db6;
  border-radius: 50%;
  position: relative;
`

export const StyledRoadMapWrapper = styled.div`
  .road-map-graph-mobile {
    display: none;
    @media screen and (max-width: 640px) {
      display: flex;
      justify-content: flex-end;
      padding: 20px 0px 50px 20px;
    }
  }

  .road-map-title {
    text-align: center;
    font-style: normal;
    font-weight: normal;
    font-size: 28px;
    line-height: 42px;
    text-align: center;
    color: #21213e;
    margin-top: 72px;
  }

  .road-map-node-wrapper {
    width: fit-content;
    position: relative;

    .road-map-node-attach {
      position: absolute;
    }

    .road-map-node-circle {
      ${roadMapCircle}
      .road-map-node-stage-stamp {
        width: 100%;
        display: flex;
        justify-content: center;
        position: absolute;
        top: -45px;
        font-style: normal;
        font-weight: 500;
        font-size: 17px;
        line-height: 25px;
        display: flex;
        align-items: center;
        color: #927ec3;
      }
    }

    .road-map-node-circle-primary {
      ${roadMapCircle}
      width: 48px;
      height: 48px;
      border: 12px solid rgba(118, 109, 182, 0.2);
      background-clip: padding-box;
    }

    .road-map-node-info-wrapper {
      margin-top: 10px;
      .road-map-node-stage {
        font-style: normal;
        font-weight: 500;
        font-size: 17px;
        line-height: 25px;
        display: flex;
        align-items: center;
        color: #45376a;
        white-space: nowrap;
      }

      .road-map-node-phase {
        font-style: normal;
        font-weight: normal;
        font-size: 17px;
        line-height: 25px;
        display: flex;
        align-items: center;
        color: #766db6;
        white-space: nowrap;
      }
    }

    .road-map-node-line-wrapper {
      display: flex;
      justify-content: center;
    }

    .road-map-node-line {
      width: 2px;
      background: #bbb5e5;
    }

    .road-map-node-line-wrapper-primary {
      display: flex;
      justify-content: center;
      position: relative;
      top: -12px;
      margin-bottom: -12px;
    }
  }
`

export const StyledRoadMapGraph = styled.div`
  margin-top: 89px;
  margin: 89px auto 125px auto;
  width: 1133px;
  height: 180px;
  position: relative;

  .road-map-nodes {
    display: flex;
    align-items: center;
  }

  .road-map-base-line {
    position: absolute;
    top: 22px;
    left: 12px;
    width: 100%;
    border: 2.01333px solid #d2d0e6;
  }
  @media screen and (max-width: 640px) {
    display: none;
  }
`
